/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'fabric.editor.chromeCollapsedPlaceholder': '내용 입력...',
  'fabric.editor.editorAssistiveLabel': '주 콘텐츠 영역입니다. 텍스트를 입력하세요.',
  'fabric.editor.headingLink.toolbarHelpTitle': '도움말 대화 상자 열기',
};
